import React from "react";
import CampaignCreateEditService from "./CampaignCreateEditService";

/*
    画面名：キャンペーン編集（MS）
 */

const CampaignEditMs: React.FC<{
    platformAccountId: number,
    campaignId: number,
    listReloadFunc: any,
}> = ({platformAccountId, campaignId,listReloadFunc}) => {
    return (
        <React.Fragment>
            <CampaignCreateEditService platformAccountId={platformAccountId} campaignId={campaignId} listReloadFunc={listReloadFunc}/>
        </React.Fragment>);
};

export default CampaignEditMs;
